require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-how-much-will-i-receive-in-social-security.json") })
        }
      }, "path---calculators-how-much-will-i-receive-in-social-security");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-how-much-will-i-receive-in-social-security!./.cache/json/calculators-how-much-will-i-receive-in-social-security.json
// module id = 2009
// module chunks = 231608221292675